import http from '../../../Utils/http';
import responseMessageHandler from '../../../Utils/ResponseMessageHandler';
const LocationsBulkUpload = {
    name: 'locationsBulkUpload',
    state: {
        data: {},
        loading: false,
        progress: 0,
        error: '',
    },
    reducers: {
        bulkUploadRequested(state) {
            return {
                ...state,
                loading: true,
                error: '',
                progress: 0,

            };
        },

        bulkUploadSucceeded(state, payload, currentProgress) {
            return {
                ...state,
                data: payload,
                loading: false,
                error: '',
                progress: currentProgress,
            };
        },

        bulkUploadFailed(state, payload) {
            return {
                ...state,
                error: payload,
                loading: false,
                progress: 0,
            };
        },
        clearStats(state) {
            return {
                ...state,
                loading: false,
                error: '',
                progress: 0,

            };
        },
    },
    effects: (dispatch) => ({
        async bulkUploadLocations(locations) {
            try {
                this.bulkUploadRequested();
                const userInfo = JSON.parse(localStorage.getItem('userInfo'));
                const org_id = userInfo?.org_id;
                let currentProgress = 0;
                function chunkArray(array, size) {
                    const result = [];
                    for (let i = 0; i < array.length; i += size) {
                        result.push(array.slice(i, i + size));
                    }
                    return result;
                }

                function getProgressPercentage(recordsUploaded, totalRecords) {
                    const raw = (recordsUploaded / totalRecords) * 100;
                    return Math.floor(raw / 5) * 5;
                }

                const BATCH_SIZE = 3000;
                const totalRecords = locations.length;
                const locationChunks = chunkArray(locations, BATCH_SIZE);
                let allResponses = [];

                let uploadedRecords = 0;
                let lastProgress = 0;

                for (const chunk of locationChunks) {
                    const payload = chunk.map(loc => ({
                        address: loc.locationAddress,
                        location_name: loc.locationName,
                        location: {
                            latitude: loc.latitude,
                            longitude: loc.longitude,
                        },
                        org_id,
                        schedule: {
                            type: loc.scheduleType,
                            slots: loc.operatingHours.slots || {},
                        },
                    }));

                    console.time('bulkUpload');
                    const response = await http.post('savvy/locations/bulk-upload', payload);
                    console.timeEnd('bulkUpload');

                    if (response && response.data) {
                        allResponses = allResponses.concat(response.data);
                        uploadedRecords += chunk.length;

                        currentProgress = getProgressPercentage(uploadedRecords, totalRecords);
                        if (currentProgress > lastProgress) {
                            lastProgress = currentProgress;

                            dispatch({
                                type: 'helper/show',
                                payload: {
                                    type: 'info',
                                    message: `Uploading... ${currentProgress}%`,
                                    show: true,
                                },
                            });
                        }
                    } else {
                        throw new Error('No data received from the server');
                    }
                }

                this.bulkUploadSucceeded(allResponses, currentProgress);
                dispatch({
                    type: 'helper/show',
                    payload: {
                        type: 'success',
                        message: 'Location bulkUpload successful!',
                        show: true,
                    },
                });
            } catch (error) {
                this.clearStats();
                this.bulkUploadFailed(error.message);
                dispatch({
                    type: 'helper/show',
                    payload: {
                        type: 'error',
                        message: responseMessageHandler.show(error.message),
                        show: true,
                    },
                });
            }
        },
        async ClearStats() {
            this.clearStats();
        }
    }),

};

export default LocationsBulkUpload;
